import React from 'react'
import { getMaskedValue } from '../../../util/document'
import PropTypes from 'prop-types'
import { TextInput } from '@olxbr/ds-web'

const DocumentInput = ({ value, onChange, documentType = 'cpf', ...props }) => {
  const onValueChange = e => {
    const maskedValue = getMaskedValue(e.target.value, documentType)
    onChange(maskedValue)
  }

  const documentPlaceholder = documentType === 'cpf' ? '000.000.000-00' : '00.000.000/0000-00'

  return (
    <TextInput
      value={value}
      onChange={onValueChange}
      id="documentType"
      label={documentType.toUpperCase()}
      type="text"
      placeholder={documentPlaceholder}
      {...props}
    />
  )
}

DocumentInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  documentType: PropTypes.string,
}

export { DocumentInput }
